import React from 'react';
import ContentSection from '../ContentSection';
import css from './insights.less';
import TripDayData from './TripDayData';
import {changeYear} from './util';

type State = any;

export default class TripDay extends React.PureComponent<{}, State> {

    state = {year: null};

    render() {
        return (
            <ContentSection title="Bookings by Trip Day" storageKey="reports-insights-trip-day">
                {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'year' does not exist on type 'IntrinsicA... Remove this comment to see the full error message */}
                <TripDayData year={this.state.year} changeYear={changeYear.bind(this)}/>
                <p className={css.reportHelpText}>Number of confirmed booking segments grouped by day-of-week of pickup
                    time.</p>
            </ContentSection>
        )
    }
}
